import { Checkbox } from "@mui/material";
import PropTypes from "prop-types";

const SelectionHeaderCheckbox = ({
  results,
  pageIndex,
  pageSize,
  selectedRows,
  onToggle,
}) => {
  const pageRows = results.slice(
    pageIndex * pageSize,
    (pageIndex + 1) * pageSize
  );
  const allPageSelected =
    pageRows.length > 0 &&
    pageRows.every((pr) => selectedRows.some((sr) => sr.id === pr.id));
  const someSelected =
    !allPageSelected &&
    pageRows.some((pr) => selectedRows.some((sr) => sr.id === pr.id));
  return (
    <Checkbox
      checked={allPageSelected}
      indeterminate={someSelected}
      onChange={(e) => onToggle(pageRows, e.target.checked)}
      onClick={(e) => e.stopPropagation()}
      sx={{
        "&.Mui-checked": {
          color: "#403C6F",
          "& .MuiSvgIcon-root": { fill: "#403C6F" },
        },
      }}
    />
  );
};


SelectionHeaderCheckbox.propTypes = {
  results: PropTypes.array,
  pageIndex: PropTypes.number,
  pageSize: PropTypes.number,
  selectedRows: PropTypes.array,
  onToggle: PropTypes.func,
};

export default SelectionHeaderCheckbox;
